import React from "react";
import { Icon } from "__ICON_REFERENCE__";

const ErrorAlert = (props) =>  {
    return (
        props.error && props.isShowAlert ?
            <div className="row margin-top-2x notice-wrapper error with-close">
                <div className="notice-body" role="alert">
                    <div className="notice-icon"><Icon name="error-solid" className="icon-24" /></div>
                    <div className="notice-message">
                        { props.error }
                    </div>
                    <div className="close-icon" onClick={() => props.closeAlert && props.closeAlert()} ><Icon name="close--n" className="wvi-icon-24" /></div>
                </div>
            </div>: null
    );
};

export default ErrorAlert;